import { BrowserModule } from "@angular/platform-browser";
import { ErrorHandler, NgModule } from "@angular/core";
import { IonicApp, IonicErrorHandler, IonicModule } from "ionic-angular";
import { SplashScreen } from "@ionic-native/splash-screen";
import { StatusBar } from "@ionic-native/status-bar";

import "rxjs/Rx";
import "rxjs/add/operator/map";
import "rxjs/add/operator/toPromise";
import { HttpModule } from "@angular/http";


// import { MaskInput } from 'mask-ioni-3/mask-input';

import { MyApp } from "./app.component";
import { CadastroPage } from "../pages/cadastro/cadastro";
import { LoginPage } from "../pages/login/login";
import { HomePage } from "../pages/home/home";
import { EsqueciPage } from "../pages/esqueci/esqueci";
import { ModalEventoPage } from "../pages/modal-evento/modal-evento";
import { RecadastramentoPage } from "../pages/recadastramento/recadastramento";

import { ModalInscricaoPage } from "../pages/modal-inscricao/modal-inscricao";
import { ModalLivroCaixaPage } from "../pages/modal-livro-caixa/modal-livro-caixa";

import { ListaOperadoresPage } from "../pages/lista-operadores/lista-operadores";
import { AuditoriaPage } from "../pages/auditoria/auditoria";

import { PerfilPage } from "../pages/perfil/perfil";
import { EventoPage } from "../pages/evento/evento";
import { ListagemEventoPage } from "../pages/listagem-evento/listagem-evento";
import { ListaExcluidosPage } from "../pages/lista-excluidos/lista-excluidos";
import { ListaImpressaoPage } from "../pages/lista-impressao/lista-impressao";

import { ListaUsuariosPage } from "../pages/lista-usuarios/lista-usuarios";
import { ListaUsuariosParceirosPage } from "../pages/lista-usuarios-parceiros/lista-usuarios-parceiros";
import { ListaParceirosPage } from "../pages/lista-parceiros/lista-parceiros";
import { LivroCaixaPage } from "../pages/livro-caixa/livro-caixa";


import { CarteirinhaPage } from "../pages/carteirinha/carteirinha";

import { AuxilioFormPage } from "../pages/auxilio-form/auxilio-form";
import { AuxilioListPage } from "../pages/auxilio-list/auxilio-list";
import { SiapePage } from "../pages/siape/siape";
import { BancosPage } from "../pages/bancos/bancos";


import { AgendamentoPage } from '../pages/agenda/agendamento/agendamento';
import { CadastroAgendaPage } from "../pages/agenda/cadastro-agenda/cadastro-agenda";
import { LiberarDiasPage } from "../pages/agenda/liberar-dias/liberar-dias";
import { ListadeSolicitacoesPage } from "../pages/agenda/listade-solicitacoes/listade-solicitacoes";
import { PlebiscitoPage } from "../pages/plebiscito/plebiscito";
import { ecAgendamentoPage } from '../pages/espaco-cultural/agendamento/ecagendamento';
import { ecCadastroAgendaPage } from "../pages/espaco-cultural/cadastro-agenda/eccadastro-agenda";
import { ecLiberarDiasPage } from "../pages/espaco-cultural/liberar-dias/ecliberar-dias";
import { ecListadeSolicitacoesPage } from "../pages/espaco-cultural/listade-solicitacoes/eclistade-solicitacoes";

@NgModule({
  declarations: [
    MyApp,
    HomePage,
    EventoPage,
    BancosPage,
    PlebiscitoPage,
    LoginPage,
    EsqueciPage,
    AuditoriaPage,
    ListaOperadoresPage,
    RecadastramentoPage,
    PerfilPage,
    SiapePage,
    LivroCaixaPage,
    ModalEventoPage,
    ModalInscricaoPage,
    ModalLivroCaixaPage,
    ListaUsuariosPage,
    ListaUsuariosParceirosPage,
    ListaExcluidosPage,
    ListagemEventoPage,
    CadastroPage,
    ListaParceirosPage,
    ListaImpressaoPage,
    CarteirinhaPage,
    AuxilioFormPage,
    AuxilioListPage,
    AgendamentoPage,
    CadastroAgendaPage,
    LiberarDiasPage,
    ListadeSolicitacoesPage,
    ecAgendamentoPage,
    ecCadastroAgendaPage,
    ecLiberarDiasPage,
    ecListadeSolicitacoesPage,


  ],
    imports: [BrowserModule, HttpModule, IonicModule.forRoot(MyApp)],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    EventoPage,
    BancosPage,
    ModalInscricaoPage,
    ModalLivroCaixaPage,
    LivroCaixaPage,
    AuditoriaPage,
    PlebiscitoPage,
    ListaExcluidosPage,
    RecadastramentoPage,
    ModalEventoPage,
    ListagemEventoPage,
    LoginPage,
    SiapePage,
    ListaOperadoresPage,
    EsqueciPage,
    PerfilPage,
    ListaUsuariosPage,
    ListaUsuariosParceirosPage,
    CadastroPage,
    ListaParceirosPage,
    ListaImpressaoPage,
    CarteirinhaPage,
    AuxilioFormPage,
    AuxilioListPage,
    AgendamentoPage,
    CadastroAgendaPage,
    LiberarDiasPage,
    ListadeSolicitacoesPage,
    ecAgendamentoPage,
    ecCadastroAgendaPage,
    ecLiberarDiasPage,
    ecListadeSolicitacoesPage,


  ],
  providers: [
    StatusBar,
    SplashScreen,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts